/**
 * Created by shubham on 19/9/18.
 */

import { Routes, RouterModule }  from '@angular/router';
import { AddApplicationComponent } from './addApplication/addApplication.component';
import { ApplicationManagementComponent } from "./applicationManagement.component";
import { ApplicationListComponent } from "./applicationList/applicationList.component";

export const ApplicationManagementRoutes: Routes = [
    {
        path: '',
        component: ApplicationManagementComponent,
        children: [
            { path: '', redirectTo: '/app/profile', pathMatch: 'full' },
            { path: 'add', component: AddApplicationComponent },
            { path: 'list', component: ApplicationListComponent },
            { path: 'view/:id', component: AddApplicationComponent }
        ]
    }
];

export const ApplicationManagementRoutingModule = RouterModule.forChild(ApplicationManagementRoutes);


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/system-level-setting/applicationManagement/applicationManagement-routing.module.ts